var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.691 12.078v8.593c0 .116.097.232.233.232h3.193a.235.235 0 00.232-.232v-8.748h2.304c.116 0 .213-.097.232-.213l.193-2.613c.02-.136-.096-.252-.232-.252H14.33V6.987c0-.445.348-.793.794-.793h1.78a.235.235 0 00.233-.233V3.348a.235.235 0 00-.233-.232h-3.019a3.197 3.197 0 00-3.194 3.194v2.535H9.104a.235.235 0 00-.232.232v2.633c0 .116.097.232.232.232h1.587v.136z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.995)",
    d: "M0 0h24v24H0z"
  })))));
}

export default "/images/facebook.svg?155a7e3930470eec4a2874e104cb6f7bdbd6743e1635711c3f2bec1b83568a7e";
export { SvgFacebook as ReactComponent };